import { render, staticRenderFns } from "./patentModal.vue?vue&type=template&id=7a557745&scoped=true"
import script from "./patentModal.vue?vue&type=script&lang=js"
export * from "./patentModal.vue?vue&type=script&lang=js"
import style0 from "./patentModal.vue?vue&type=style&index=0&id=7a557745&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a557745",
  null
  
)

export default component.exports